import { CancelAppointmentUseCase } from '@/core/appointment/application/CancelAppointmentUseCase.ts'
import { CreateAppointmentUseCase } from '@/core/appointment/application/CreateAppointmentUseCase.ts'
import { EditAppointmentUseCase } from '@/core/appointment/application/EditAppointmentUseCase.ts'
import { GetAppointmentUseCase } from '@/core/appointment/application/GetAppointmentUseCase.ts'
import { GetAvailabilityUseCase } from '@/core/availability/application/GetAvailabilityUseCase.ts'
import { GetBrandsUseCase } from '@/core/brand/application/GetBrandsUseCase.ts'
import { GetCookiesUrlUseCase } from '@/core/cookies/application/GetCookiesUrlUseCase.ts'
import { GetPPSOPackagesUseCase } from '@/core/ppso-package/application/GetPPSOPackageUseCase.ts'
import { GetServicesUseCase } from '@/core/service/application/GetServicesUseCase.ts'
import { GetVehicleByPlateUseCase } from '@/core/vehicle/application/GetVehicleByPlateUseCase.ts'
import { GetWorkshopsUseCase } from '@/core/workshop/application/GetWorkshopsUseCase.ts'

export type DependenciesProvider = {
  cancelAppointmentUseCase: CancelAppointmentUseCase
  createAppointmentUseCase: CreateAppointmentUseCase
  editAppointmentUseCase: EditAppointmentUseCase
  getAppointmentUseCase: GetAppointmentUseCase
  getBrandsUseCase: GetBrandsUseCase
  getCookiesUrlUseCase: GetCookiesUrlUseCase
  getPPSOPackagesUseCase: GetPPSOPackagesUseCase
  getServicesUseCase: GetServicesUseCase
  getVehicleByPlateUseCase: GetVehicleByPlateUseCase
  getWorkshopAvailabilityUseCase: GetAvailabilityUseCase
  getWorkshopsUseCase: GetWorkshopsUseCase
}

export const DEPENDENCIES_TOKEN = 'dependencies'
